import React from 'react';
import PropTypes from 'prop-types';
import mitt from 'mitt';
var contextTypes = {
  reactBus: PropTypes.object
};
export function withBus(name) {
  if (name === void 0) name = 'bus';
  return function decorate(BaseComponent) {
    function WithBus(props, context) {
      var obj;
      return React.createElement(BaseComponent, Object.assign({}, props, (obj = {}, obj[name] = context.reactBus, obj)));
    }

    WithBus.contextTypes = contextTypes;
    return WithBus;
  };
}
export var Provider = function (superclass) {
  function Provider(props) {
    superclass.call(this, props);
    this.bus = mitt();
  }

  if (superclass) Provider.__proto__ = superclass;
  Provider.prototype = Object.create(superclass && superclass.prototype);
  Provider.prototype.constructor = Provider;

  Provider.prototype.getChildContext = function getChildContext() {
    return {
      reactBus: this.bus
    };
  };

  Provider.prototype.render = function render() {
    return this.props.children;
  };

  return Provider;
}(React.Component);
Provider.childContextTypes = contextTypes;